import { ProductTokens } from '../types'
import { colors, TheWestPalette } from './colors'

export const thewest: ProductTokens<TheWestPalette> = {
    colors,
}
